module.exports = __webpack_public_path__ + "img/auction.4baacb5.png";